// @ts-nocheck
import { GridContainerProps } from "@insite/mobius/GridContainer";
import React, { FC } from "react";
import Zone from "@insite/client-framework/Components/Zone";
import Wave from "@store/Library/Components/Wave/Wave";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { css, useTheme } from "styled-components";
import useIsBreakpoint from "@toolkit/Framework/Common/Hooks/useIsBreakpoint";
import { resolveColor } from "@insite/mobius/utilities";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";

export interface WaveWrapperProps {
    id: string;
    hasTopWave?: boolean;
    hasBottomWave?: boolean;
    waveColor?: string;
}

export interface WaveWrapperStyles {
    container?: GridContainerProps;
}

export const waveWrapperStyles: WaveWrapperStyles = {
    container: {
        css: css`
            position: relative;
        `,
    },
};

const WaveWrapper: FC<WaveWrapperProps> = ({ id, hasTopWave, hasBottomWave, waveColor }) => {
    const isMobile = useIsBreakpoint("xs", "down");
    const theme = useTheme();

    const styles = mergeProps<WaveWrapperStyles>(waveWrapperStyles, {
        container: {
            css: css`
                ${hasTopWave && `margin-top: ${pxToRem(45)}`}
            `,
        },
    });

    return (
        <StyledWrapper {...styles.container}>
            {hasTopWave && (
                <Wave
                    isTop
                    color={resolveColor(waveColor, theme)}
                    backgroundColor={"transparent"}
                    isMobile={isMobile}
                />
            )}
            <Zone contentId={id} zoneName="Content" />
            {hasBottomWave && (
                <Wave color={resolveColor(waveColor, theme)} backgroundColor={"transparent"} isMobile={isMobile} />
            )}
        </StyledWrapper>
    );
};

export default WaveWrapper;
